import { useTranslation } from 'react-i18next';
import TextField from 'shared/components/form/TextField';
import { UpdateFormT } from 'shared/form-values/settings';

const Form = () => {
  const { t } = useTranslation();

  const fieldProps = {
    mb: '20px',
    w: {
      base: '100%',
      md: '50%',
    },
  };

  return (
    <>
      <TextField<UpdateFormT>
        name="value"
        label={t('services.table.value')}
        placeholder={t('services.table.value')}
        required
        {...fieldProps}
      />
      <TextField<UpdateFormT>
        name="description"
        label={t('services.table.description')}
        placeholder={t('services.table.description')}
        required
        {...fieldProps}
      />
    </>
  );
};

export default Form;
